/* 🤖 this file was generated by script */
export const wsolidiconUpload03 = {
  name: 'upload_03',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22M7.3 11.3l4-4a1 1 0 0 1 1.4 0l4 4a1 1 0 0 1-1.4 1.4L13 10.42V16a1 1 0 1 1-2 0v-5.59l-2.3 2.3a1 1 0 0 1-1.4-1.42" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
